export default "__VITE_ASSET__Dd45JTrF__"